import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";

export default class extends Controller {
  connect() {
    this._tooltips = [];
    this.initializeTooltips();
    this.initializePopovers();
    this.initializeToasts();
  }

  disconnect() {
    this._tooltips.forEach((t) => {
      try {
        t.hide();
      } catch (e) {}
      
      try {
        t.dispose();
      } catch (e) {}
    });
    this._tooltips = [];
  }

  initializeTooltips() {
    this.element
      .querySelectorAll("[data-bs-toggle='tooltip']")
      .forEach((el) => {
        if (el.closest('[data-controller~="ajax-bs-elements"]') !== this.element) return;
        const instance = bootstrap.Tooltip.getOrCreateInstance(el);
        this._tooltips.push(instance);
      });
  }

  initializePopovers() {
    this.element
      .querySelectorAll("[data-bs-toggle='popover']")
      .forEach((popover) => {
        if (popover.closest('[data-controller~="ajax-bs-elements"]') !== this.element) return;
        bootstrap.Popover.getOrCreateInstance(popover);
      });
  }

  initializeToasts() {
    this.element
      .querySelectorAll("[data-bs-toggle='toast']")
      .forEach((toast) => {
        if (toast.closest('[data-controller~="ajax-bs-elements"]') !== this.element) return;
        bootstrap.Toast.getOrCreateInstance(toast);
      });
  }
}
